// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'asset-depreciation-schedule.page.title': 'Asset Depreciation Schedules',
    'asset-depreciation-schedule.page.search_results': 'Search Results',
    'asset-depreciation-schedule.page.create.title': 'Create New Asset Depreciation Schedule',
    'asset-depreciation-schedule.page.search.title': 'Find Asset Depreciation Schedules',
    'asset-depreciation-schedule.page.edit.title': 'Edit Asset Depreciation Schedule',
    'asset-depreciation-schedule.page.view.title': 'View Asset Depreciation Schedule',
    'asset-depreciation-schedule.page.all': 'All',

    'asset-depreciation-schedule.button.cancel': 'Cancel',
    'asset-depreciation-schedule.button.select': 'Select',
    'asset-depreciation-schedule.button.find': 'Find Asset Depreciation Schedules',
    'asset-depreciation-schedule.button.search': 'Apply',
    'asset-depreciation-schedule.button.create': 'Create Asset Depreciation Schedule',
    'asset-depreciation-schedule.button.new': 'New Asset Depreciation Schedule',
    'asset-depreciation-schedule.button.save': 'Save Changes',
    'asset-depreciation-schedule.button.delete': 'Permanently Delete',
    'asset-depreciation-schedule.button.edit': 'Edit',
    'asset-depreciation-schedule.button.restore': 'Restore',
    'asset-depreciation-schedule.button.reset': 'Reset',

    'asset-depreciation-schedule.placeholder.search': 'Search asset depreciation schedules',

    'asset-depreciation-schedule.link.create_first_asset_depreciation_schedule': 'Click here to create your first asset depreciation schedule',
    'asset-depreciation-schedule.link.asset_depreciation_schedules': ' Return to Asset Depreciation Schedules',
    'asset-depreciation-schedule.link.retry': 'Click here to retry',

    'asset-depreciation-schedule.checkbox.all': 'Check All',
    'asset-depreciation-schedule.checkbox.actions_label': 'with selected',

    'asset-depreciation-schedule.label.asset_name': 'Asset',
    'asset-depreciation-schedule.label.from_date': 'From Date',
    'asset-depreciation-schedule.label.thru_date': 'Thru Date',
    'asset-depreciation-schedule.label.depreciation_amount_in_cents': 'Depreciation Amount',
    'asset-depreciation-schedule.label.current_value_in_cents': 'Value',

    'asset-depreciation-schedule.sort.field_label': 'Field',
    'asset-depreciation-schedule.sort.direction_label': 'Direction',
    'asset-depreciation-schedule.sort.direction_ascending': 'Ascending',
    'asset-depreciation-schedule.sort.direction_descending': 'Descending',

    'asset-depreciation-schedule.modal.title.asset_depreciation_schedule_delete_permanently': 'Delete Asset Depreciation Schedule',
    'asset-depreciation-schedule.modal.title.asset_depreciation_schedule_restore': 'Restore Asset Depreciation Schedule',

    'asset-depreciation-schedule.modal.message.asset_depreciation_schedule_delete_permanently':
        'Are you sure that you want to permanently delete this asset depreciation schedule? This action cannot be undone. | Are you sure that you want to permanently delete these asset depreciation schedules? This action cannot be undone.',
    'asset-depreciation-schedule.modal.message.asset_depreciation_schedule_restore': 'Are you sure that you want to restore this asset depreciation schedule? | Are you sure that you want to restore these asset depreciation schedules?',

    'asset-depreciation-schedule.success.message.asset_depreciation_schedule_created': 'Your asset depreciation schedule has been created',
    'asset-depreciation-schedule.success.message.asset_depreciation_schedule_updated': 'Your asset depreciation schedule has been updated',
    'asset-depreciation-schedule.success.message.asset_depreciation_schedule_restored': 'Your asset depreciation schedule has been restored | All selected asset depreciation schedules were restored',
    'asset-depreciation-schedule.success.message.asset_depreciation_schedule_deleted': 'Your asset depreciation schedule has been permanently deleted | All selected asset depreciation schedules were permanently deleted',

    'asset-depreciation-schedule.error.message.asset_depreciation_schedule_deleted': 'This asset depreciation schedule was already permanently deleted | These asset depreciation schedules were already permanently deleted',
    'asset-depreciation-schedule.error.message.asset_depreciation_schedule_restored': 'This asset depreciation schedule was already restored | These asset depreciation schedules were already restored',
    'asset-depreciation-schedule.error.message.error_loading_page': 'Sorry, there was an error loading asset depreciation schedule.| Sorry, there was an error loading asset depreciation schedules.',
};
